import { render, staticRenderFns } from "./Entreprises.vue?vue&type=template&id=a878a314"
import script from "./Entreprises.vue?vue&type=script&lang=ts"
export * from "./Entreprises.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports